import React from 'react';

const Compare = () => {
  const products = [
    {
      className: "others",
      imgSrc: "images/others.png",
      size :  {
            width : 334,
            height : 511,
      },
      imgAlt: "other product",
      features: [
        "Fades after a few hours",
        "Leaves sticky residue",
        "Contains synthetic oils",
        "Limited to basic use",
        "Slow, feels heavy",
        "Basic moisture only",
        "Artificial fragrance",
        "Regular packaging",
      ],
    },
    {
      className: "diddy",
      imgSrc: "images/diddy.png",
      size : {
            width : 243,
            height : 468,
      },
      imgAlt: "diddy product",
      features: [
        "All-day moisture",
        "Lightweight & silky",
        "100% natural oils",
        "Versatile for all moods",
        "Fast-absorbing, smooth",
        "Designed for intimacy",
        "Subtle, natural aroma",
        "Sustainable & recyclable",
      ],
    },
  ];

  return (
    <section className="compare">
      <div className="container-xl">
        <div className="row">
          <div className="compare-box">
            {products.map(({ className, imgSrc, imgAlt, features, size }, index) => (
              <div className={className} key={index}>
                <div className="pr-img">
                  <img src={imgSrc} alt={imgAlt} width={size.width} height={size.height} loading='lazy' decoding='async' />
                </div>
                <ul>
                  {features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compare;
